import { communityConfigService } from '@/services/community-config.service'
import tenantService from '@/services/tenant.service'
import { normalizeHostname } from '@/utils/domain-branding-resolver'
import { getTenantFromHost, isCustomDomainLookupCandidate } from '@/utils/tenant.utils'

export { isResolvableCustomDomainHost } from '@/utils/tenant.utils'

/**
 * Resolve tenant slug for API/config: subdomain from host, or custom domain via community / tenant API.
 */
export async function resolveTenantSubdomainFromHostname(
  hostname: string | null | undefined
): Promise<string> {
  const normalized = normalizeHostname(hostname)
  if (!normalized) {
    return 'default'
  }

  const fromHost = getTenantFromHost(normalized)
  if (!isCustomDomainLookupCandidate(normalized)) {
    return fromHost
  }

  try {
    const community = await communityConfigService.getByDomain(normalized)
    const subdomain = community?.subdomain?.trim().toLowerCase()
    if (subdomain) {
      return subdomain
    }
  } catch {
    // Fall through to tenant config API
  }

  try {
    const config = await tenantService.getTenantBySubdomain(normalized, normalized)
    const subdomain = config?.subdomain?.trim().toLowerCase()
    if (subdomain) {
      return subdomain
    }
  } catch {
    // Unresolved custom domain
  }

  // Unresolved custom domain: return 'default' for general routing/config purposes.
  // Note: resolveGeneratedContentTenantId treats this as null (fail-closed) so that
  // the middleware refuses to sign a principal for an unverified host.
  return 'default'
}
